exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_bj_box[data-v-5f1e9179] {\n  background-color: #eeeeee;\n  margin: 20px;\n  padding: 20px 120px 20px 20px;\n  border-radius: 5px;\n}\n.form_bj_box .form_bj_box_title[data-v-5f1e9179] {\n    padding: 20px;\n    color: #ff3040;\n    font-size: 18px;\n    font-weight: bold;\n}\n.form_bj_box .form_bj_box_tips[data-v-5f1e9179] {\n    color: #ff3040;\n    text-align: center;\n    font-size: 12px;\n}\n.no_bjc[data-v-5f1e9179] {\n  background-color: #fff;\n}\n", ""]);

// exports
